import { IconKey,IconChecklist } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconChecklist
};
//

const Audit_Complaince = {

    id: 'Audit_Complaince',
    title: 'Audit and Compliance',
    type: 'group',
    display_id:'J',
    icon: icons.IconChecklist,
    children: [
        {
            id: 'Audit_Complaince_transaction',
            title: 'Transaction',
            type: 'item',
            display_id:54,
            url: '/Department/audit/transaction',
            breadcrumbs: false
        },
        {
            id: 'Audit_Complaince_activity',
            title: 'Activity',
            type: 'item',
            display_id:57,
            url: '/Department/audit/activity',
            breadcrumbs: false
        },
    ]
}

export default Audit_Complaince;
